// Имя параметра публичного токена в URL.
export const PublicTokenParamName = 'public_token' as const;
